import { palette } from '@styles/theme';

/** 혁신의숲 URL */
export const INNOFOREST_URL = 'https://www.innoforest.co.kr';

/** 보고서 - 보고서 자료 유형 */
export const REPORT_DATA_TYPE: any[] = [
  {
    label: '재무상태표',
    value: 'BALANCE_SHEET',
  },
  {
    label: '손익계산서',
    value: 'INCOME_STATEMENT',
  },
  {
    label: '자본변동표',
    value: 'CHANGES_IN_EQUITY',
  },
  {
    label: '4대보험 가입자명부',
    value: 'REGISTER_OF_SOCIAL_INSURANCE',
  },
  {
    label: '주주명부',
    value: 'SHAREHOLDER_LIST',
  },
  {
    label: '주식미발행확인서',
    value: 'UNISSUED_CERTIFICATE',
  },
  {
    label: '성과 및 계획',
    value: 'YEARLY_REPORT',
  },
  {
    label: '기타',
    value: 'OTHERS',
  },
];

/** 보고서 - 결산유형 (구)결산유형 */
export const SETTLEMENT_PERIOD_TYPE: any[] = [
  {
    label: '연간',
    value: 'YEARLY',
  },
  {
    label: '상반기',
    value: 'FIRST_HALF_YEAR',
  },
  {
    label: '하반기',
    value: 'SECOND_HALF_YEAR',
  },
  {
    label: '분기',
    value: 'QUARTER',
  },
  {
    label: '1분기',
    value: 'FIRST_QUARTER',
  },
  {
    label: '2분기',
    value: 'SECOND_QUARTER',
  },
  {
    label: '3분기',
    value: 'THIRD_QUARTER',
  },
  {
    label: '4분기',
    value: 'FOURTH_QUARTER',
  },
];

/** 보고서 - 신 결산유형 */
export const SETTLEMENT_TYPE: any[] = [
  {
    label: '가결산',
    value: 'TENTATIVE',
  },
  {
    label: '확정',
    value: 'CONFIRMED',
  },
];

/** 보고서 - 결산시기 (구 결산유형 대체) */
export const SETTLEMENT_PERIOD: any[] = [
  {
    label: '월',
    value: 'MONTHLY',
  },
  {
    label: '분기',
    value: 'QUARTERLY',
  },
  {
    label: '반기',
    value: 'HALF',
  },
  {
    label: '온기',
    value: 'FULL',
  },
];

/** 참조  데이터 - 거래쳐 유형 */
export const CUSTOMER_TYPE: any[] = [
  {
    label: '매입',
    value: 'BUY',
  },
  {
    label: '매출',
    value: 'SELL',
  },
];

/**
 * ========================================================================================================================
 * ========================================================================================================================
 */

interface SelectBoxTypes {
  label: string;
  value: string;
  color: string;
}

// export const GROUP_TYPES: Omit<SelectBoxTypes, 'color'>[] = [
//   {
//     label: '사업유형1',
//     value: 'type1',
//   },
//   {
//     label: '사업유형2',
//     value: 'type2',
//   },
//   {
//     label: '사업유형3',
//     value: 'type3',
//   },
// ];

export const GROUP_STATUS: SelectBoxTypes[] = [
  {
    label: '운용중',
    value: 'IN_OPERATION',
    color: palette.primaryColor,
  },
  {
    label: '종료',
    value: 'DISSOLUTION',
    color: palette.gray6,
  },
];

export const GROUP_STATUS_NO_COLOR: Omit<SelectBoxTypes, 'color'>[] = [
  {
    label: '운용중',
    value: 'IN_OPERATION',
  },
  {
    label: '종료',
    value: 'DISSOLUTION',
  },
];

export const ACCOUNT_ROLE: Omit<SelectBoxTypes, 'color'>[] = [
  {
    label: '관리자',
    value: 'ROLE_CLIENT',
  },
  {
    label: '담당자',
    value: 'ROLE_MANAGER',
  },
  {
    label: '참여자',
    value: 'ROLE_PARTNER',
  },
];

/** 기업 운영상태 */
export const CORP_STATUS: SelectBoxTypes[] = [
  {
    label: '운영중',
    value: 'IN_OPERATION',
    color: palette.primaryColor,
  },
  {
    label: '합병해산',
    value: 'MERGED',
    color: palette.colorBlue200,
  },
  {
    label: '종료',
    value: 'CLOSED',
    color: palette.gray6,
  },
  {
    label: '기타',
    value: 'ETC',
    color: palette.gray4,
  },
];

/** 투자단계 목록 */
export const INVESTMENT_LEVEL: any[] = [
  {
    value: 'SEED',
    label: 'seed',
    priority: 1,
  },
  {
    value: 'PRE_A',
    label: 'pre-A',
    priority: 2,
  },
  {
    value: 'SERIES_A',
    label: 'series A',
    priority: 3,
  },
  {
    value: 'PRE_B',
    label: 'pre-B',
    priority: 4,
  },
  {
    value: 'SERIES_B',
    label: 'series B',
    priority: 5,
  },
  {
    value: 'SERIES_C',
    label: 'series C',
    priority: 6,
  },
  {
    value: 'SERIES_D',
    label: 'series D',
    priority: 7,
  },
  {
    value: 'SERIES_E',
    label: 'series E',
    priority: 8,
  },
  {
    value: 'SERIES_F',
    label: 'series F',
    priority: 9,
  },
  {
    value: 'SERIES_G',
    label: 'series G',
    priority: 10,
  },
  {
    value: 'PRE_IPO',
    label: 'pre-IPO',
    priority: 11,
  },
  {
    value: 'IPO',
    label: 'IPO',
    priority: 12,
  },
  {
    value: 'SUPPORT_FUND',
    label: '지원금',
    priority: 13,
  },
  {
    value: 'STOCK_TRADE',
    label: '주식양수도',
    priority: 14,
  },
  {
    value: 'MNA',
    label: 'M&A',
    priority: 15,
  },
  {
    value: 'UNKNOWN',
    label: '비공개',
    priority: 16,
  },
];

/** 조합구분 OPTIONS */
export const GROUP_TYPES: Omit<SelectBoxTypes, 'color'>[] = [
  {
    label: '벤처투자조합',
    value: 'VENTURE',
  },
  {
    label: '개인투자조합',
    value: 'INDIVIDUAL',
  },
  {
    label: '고유계정',
    value: 'PROPRIETARY',
  },
  {
    label: 'PEF',
    value: 'PEF',
  },
  {
    label: '기타',
    value: 'OTHERS',
  },
];

/** 주식유형 OPTIONS */
export const STOCK_TYPES: Omit<SelectBoxTypes, 'color'>[] = [
  {
    label: '전환우선주',
    value: 'CPS',
  },
  {
    label: '조건부지분인수계약',
    value: 'SAFE',
  },
  {
    label: '보통주',
    value: 'CS',
  },
  {
    label: '상환전환우선주',
    value: 'RCPS',
  },
  {
    label: '전환사채',
    value: 'CB',
  },
  {
    label: '신주인수권부사채',
    value: 'BW',
  },
];

/** 주식 발행 유형 */
export const STOCK_ISSUANCE_TYPES: Omit<SelectBoxTypes, 'color'>[] = [
  {
    label: '법인설립',
    value: 'ESTABLISHMENT',
  },
  {
    label: '유상증자',
    value: 'CIC',
  },
  {
    label: '무상증자',
    value: 'BS',
  },
  {
    label: '감자',
    value: 'RCS',
  },
  {
    label: '액면분할',
    value: 'STOCK_SPLIT',
  },
];

/** 투자자산 거래 구분 */
export const TRANSACTION_TYPES: Omit<SelectBoxTypes, 'color'>[] = [
  {
    label: '투자',
    value: 'INVESTMENT',
  },
  {
    label: '유상증자',
    value: 'PAID_IN_CAPITAL',
  },
  {
    label: '유상증자(스톡옵션)',
    value: 'PAID_IN_CAPITAL_STOCK_OPTION',
  },
  {
    label: '무상증자',
    value: 'FREE_CAPITAL_INCREASE',
  },
  {
    label: '액면분할',
    value: 'FACE_VALUE_SPLIT',
  },
  {
    label: '전환(+)',
    value: 'CONVERSION_PLUS',
  },
  {
    label: '전환(-)',
    value: 'CONVERSION_MINUS',
  },
  {
    label: '손상차손',
    value: 'IMPAIRMENT_LOSS',
  },
  {
    label: '회수',
    value: 'RECOVERY',
  },
];

/** 자본금 변동내역 거래 구분 */
export const CAPITAL_CHANGE_TRANSACTION_TYPES: Omit<SelectBoxTypes, 'color'>[] =
  [
    {
      label: '투자',
      value: 'INVESTMENT',
    },
    {
      label: '후속투자',
      value: 'FOLLOW_ON_INVESTMENT',
    },
    {
      label: '스톡옵션',
      value: 'STOCK_OPTION',
    },
    {
      label: '-',
      value: 'NONE',
    },
  ];

/** 사후관리 구분 */
export const POST_MANAGEMENT_TYPES: Omit<SelectBoxTypes, 'color'>[] = [
  {
    label: '기업현황',
    value: 'COMPANY_STATUS',
  },
  {
    label: '보고사항',
    value: 'REPORT_MATTER',
  },
  {
    label: '동의사항',
    value: 'CONSENT_MATTER',
  },
];

/** 보도자료 유형 */
export const PRESS_TYPES: Omit<SelectBoxTypes, 'color'>[] = [
  {
    label: '일반',
    value: 'NORMAL',
  },
  {
    label: '투자',
    value: 'INVEST',
  },
];
